// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__HRaML","name":"ConsentHeader_name__2bOo4","birthday":"ConsentHeader_birthday__3MX-l","skeleton":"ConsentHeader_skeleton__1gFeY"};